import React from "react";
import { useAssetsMoveModel } from "../assetsMoveModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsMoveModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "转移单号",
            fieldName: "code",
            span: 4
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "转移人员",
            fieldName: "createUser",
            span: 4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "转出部门",
            fieldName: "departmentOut",
            // fieldName: "department",
            span: 4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "转入部门",
            fieldName: "department",
            // fieldName: "departmentIn",
            span: 4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["转移起始日期", "转移结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span: 4
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "申请单号",
            fieldName: "applyCode",
            span: 4
        },
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}